import { Trans } from '@ecomm/i18n'
import { useTranslation } from '@ecomm/i18n'
import { ComparisonCell } from '../ComparisonCell'
import { ComparisonRow } from '../ComparisonRow'

export function RowMonitoring() {
  const { t } = useTranslation('maps')

  return (
    <ComparisonRow
      title={t('feature-title.professional-monitoring')}
      description={t('feature-description.professional-monitoring')}
      modalDescription={
        <Trans
          t={t}
          i18nKey="feature-tooltip.professional-monitoring-business"
        />
      }
    >
      <ComparisonCell included={true} />
      <ComparisonCell included={true} />
      <ComparisonCell included={true} />
    </ComparisonRow>
  )
}
